export const apiRoutes = {
  rumApi: {
    baseUrl: import.meta.env.VITE_RUMAPI_BASE_URL || "http://localhost:3000",
    fetchLiveUsersServiceUrl:
      import.meta.env.VITE_FETCH_LIVE_USERS_SERVICE_URL ||
      "/v1/metrics/live-users",
    fetchLiveQueriesServiceUrl:
      import.meta.env.VITE_FETCH_LIVE_QUERIES_SERVICE_URL ||
      "/v1/metrics/live-queries",
    fetchPeakUsersServiceUrl:
      import.meta.env.VITE_FETCH_PEAK_USERS_SERVICE_URL ||
      "/v1/metrics/peak-users",
    fetchPeakQueriesServiceUrl:
      import.meta.env.VITE_FETCH_PEAK_QUERIES_SERVICE_URL ||
      "/v1/metrics/peak-queries",
    fetchTotalUsersServiceUrl:
      import.meta.env.VITE_FETCH_TOTAL_USERS_SERVICE_URL ||
      "/v1/metrics/total-users",
    fetchFailedResponsesServiceUrl:
      import.meta.env.VITE_FAILED_RESPONSE_SERVICE_URL ||
      "/v1/metrics/failed-responses",
    fetchSuccessRequestsServiceUrl:
      import.meta.env.VITE_SUCCESS_REQUEST_SERVICE_URL ||
      "/v1/metrics/success-requests",
    fetchLiveUsersHourlyServiceUrl:
      import.meta.env.VITE_LIVE_USERS_HOURLY_SERVICE_URL ||
      "/v1/metrics/live-users-hourly",
    fetchLiveQueriesHourlyServiceUrl:
      import.meta.env.VITE_LIVE_QUERIES_HOURLY_SERVICE_URL ||
      "/v1/metrics/live-queries-hourly",
    fetchAverageDailyUsersServiceUrl:
      import.meta.env.VITE_AVERAGE_DAILY_USERS_SERVICE_URL ||
      "/v1/metrics/average-daily-users",
    fetchAverageDailyQueriesServiceUrl:
      import.meta.env.VITE_AVERAGE_DAILY_QUERIES_SERVICE_URL ||
      "/v1/metrics/average-daily-queries",
    fetchZoneWiseActiveUsersServiceUrl:
      import.meta.env.VITE_ZONE_WISE_USERS_SERVICE_URL ||
      "/v1/metrics/zone-wise-active-users",
    fetchVerticalWiseActiveUsersServiceUrl:
      import.meta.env.VITE_VERTICAL_WISE_USERS_SERVICE_URL ||
      "/v1/metrics/vertical-wise-active-users",
    fetchAverageEngagementTimeServiceUrl:
      import.meta.env.VITE_AVERAGE_ENGAGEMENT_TIME_SERVICE_URL ||
      "/v1/metrics/average-engagement-time",
    fetchScaleWiseActiveUsersServiceUrl:
      import.meta.env.VITE_SCALE_WISE_USERS_SERVICE_URL ||
      "/v1/metrics/scale-wise-active-users",
  },
  // Microserice level API routes
  organizationManagementService: {
    baseUrl:
      import.meta.env.VITE_ORG_MANAGEMENT_SERVICE_BASE_URL ||
      "http://localhost:3003",
    // Auth endpoints
    authentication: {
      loginServiceUrl:
        import.meta.env.VITE_LOGIN_SERVICE_URL || "/v1/auth/login",
      logoutServiceUrl:
        import.meta.env.VITE_LOGOUT_SERVICE_URL || "/v1/auth/logout",
      refreshTokenServiceUrl:
        import.meta.env.VITE_REFRESH_TOKEN_SERVICE_URL || "/v1/auth/refresh",
    },
    // Organization endpoints
    organization: {
      listServiceUrl:
        import.meta.env.VITE_ORG_LIST_SERVICE_URL || "/v1/org/list",
      createServiceUrl:
        import.meta.env.VITE_ORG_CREATE_SERVICE_URL || "/v1/org/create",
      deleteServiceUrl:
        import.meta.env.VITE_ORG_DELETE_SERVICE_URL || "/v1/org/delete",
      updateServiceUrl:
        import.meta.env.VITE_ORG_UPDATE_SERVICE_URL || "/v1/org/update",
      getServiceUrl:
        import.meta.env.VITE_ORG_UPDATE_SERVICE_URL || "/v1/org/get",
    },
    // Group endpoints
    group: {
      listServiceUrl:
        import.meta.env.VITE_GROUP_LIST_SERVICE_URL || "/v1/group/list",
      createServiceUrl:
        import.meta.env.VITE_GROUP_CREATE_SERVICE_URL || "/v1/group/create",
      deleteServiceUrl:
        import.meta.env.VITE_GROUP_DELETE_SERVICE_URL || "/v1/group/delete",
      updateServiceUrl:
        import.meta.env.VITE_GROUP_UPDATE_SERVICE_URL || "/v1/group/update",
      getServiceUrl:
        import.meta.env.VITE_GROUP_GET_SERVICE_URL || "/v1/group/get",
      addUserServiceUrl:
        import.meta.env.VITE_GROUP_ADD_USER_SERVICE_URL || "/v1/group/user/add",
      removeUserServiceUrl:
        import.meta.env.VITE_GROUP_REMOVE_USER_SERVICE_URL ||
        "/v1/group/user/remove",
    },
    user: {
      listServiceUrl:
        import.meta.env.VITE_ORG_LIST_USERS_SERVICE_URL || "/v1/user/list",
      getGroupServiceUrl:
        import.meta.env.VITE_ORG_GET_USERS_GROUP_SERVICE_URL ||
        "/v1/user/groups/get",
      createServiceUrl:
        import.meta.env.VITE_ORG_CREATE_USER_SERVICE_URL || "/v1/user/create",
      getServiceUrl:
        import.meta.env.VITE_ORG_GET_USER_SERVICE_URL || "/v1/user/get",
      updateServiceUrl:
        import.meta.env.VITE_ORG_UPDATE_USER_SERVICE_URL || "/v1/user/update",
      deleteServiceUrl:
        import.meta.env.VITE_ORG_DELETE_USER_SERVICE_URL || "/v1/user/delete",
    },
  },
  inferenceFastApiService: {
    baseUrl:
      import.meta.env.VITE_INFERENCE_FAST_API_SERVICE_BASE_URL ||
      "http://localhost:3011",
    chat: {
      sendSendServiceUrl:
        import.meta.env.VITE_CHAT_SEND_SERVICE_URL || "/v1/chat/send",
      generateTitleServiceUrl:
        import.meta.env.VITE_CHAT_GENERATE_TITLE_SERVICE_URL ||
        "/v1/chat/generate-title",
    },
  },
  inferenceConfigurationService: {
    baseUrl:
      import.meta.env.VITE_INFERENCE_CONFIGURATION_BASE_URL ||
      "http://localhost:3004",
    promptGuidance: {
      deleteServiceUrl:
        import.meta.env.VITE_PROMPT_GUIDANCE_DELETE_SERVICE_URL ||
        "/v1/prompt-guidance/delete",
      createServiceUrl:
        import.meta.env.VITE_PROMPT_GUIDANCE_CREATE_SERVICE_URL ||
        "/v1/prompt-guidance/create",
      getServiceUrl:
        import.meta.env.VITE_PROMPT_GUIDANCE_GET_SERVICE_URL ||
        "/v1/prompt-guidance/get",
      updateServiceUrl:
        import.meta.env.VITE_PROMPT_GUIDANCE_GET_SERVICE_URL ||
        "/v1/prompt-guidance/update",
    },
    queryLibrary: {
      listServiceUrl:
        import.meta.env.VITE_QUERY_LIBRARY_LIST_URL || "/v1/query-library/list",
      getServiceUrl:
        import.meta.env.VITE_QUERY_LIBRARY_GET_URL || "/v1/query-library/get",
      createServiceUrl:
        import.meta.env.VITE_QUERY_LIBRARY_CREATE_URL ||
        "/v1/query-library/add",
      updateServiceUrl:
        import.meta.env.VITE_QUERY_LIBRARY_UPDATE_URL ||
        "/v1/query-library/update",
      deleteServiceUrl:
        import.meta.env.VITE_QUERY_LIBRARY_DELETE_URL ||
        "/v1/query-library/delete",
    },
    agent: {
      createServiceUrl:
        import.meta.env.VITE_INFERENCE_CONFIG_AGENT_CREATE_SERVICE_URL ||
        "/v1/agent/create",
      updateServiceUrl:
        import.meta.env.VITE_INFERENCE_CONFIG_AGENT_UPDATE_SERVICE_URL ||
        "/v1/agent/update",
      deleteServiceUrl:
        import.meta.env.VITE_INFERENCE_CONFIG_AGENT_DELETE_SERVICE_URL ||
        "/v1/agent/delete",
      getServiceUrl:
        import.meta.env.VITE_INFERENCE_CONFIG_AGENT_GET_SERVICE_URL ||
        "/v1/agent/get",
      listServiceUrl:
        import.meta.env.VITE_INFERENCE_CONFIG_AGENT_LIST_SERVICE_URL ||
        "/v1/agent/list",
    },
    chatFeedback: {
      addServiceUrl:
        import.meta.env.VITE_CHAT_FEEDBACK_ADD_SERVICE_URL ||
        "/v1/chat-feedback/add",
      updateServiceUrl:
        import.meta.env.VITE_CHAT_FEEDBACK_UPDATE_SERVICE_URL ||
        "/v1/chat-feedback/update",
      summaryServiceUrl:
        import.meta.env.VITE_CHAT_FEEDBACK_SUMMARY_SERVICE_URL ||
        "/v1/chat-feedback/summary",
    },
    chat: {
      getByIdServiceUrl:
        import.meta.env.VITE_CHAT_GET_SERVICE_URL || "/v1/chat/get",
      listServiceUrl:
        import.meta.env.VITE_CHAT_LIST_SERVICE_URL || "/v1/chat/list",
      deleteByIdServiceUrl:
        import.meta.env.VITE_CHAT_DELETE_SERVICE_URL || "/v1/chat/delete",
    },
    knowledge: {
      deleteServiceUrl:
        import.meta.env.VITE_KNOWLEDGE_DELETE_SERVICE_URL ||
        "/v1/knowledge/delete",
      getServiceUrl:
        import.meta.env.VITE_KNOWLEDGE_GET_SERVICE_URL || "/v1/knowledge/get",
      listServiceUrl:
        import.meta.env.VITE_KNOWLEDGE_LIST_SERVICE_URL || "/v1/knowledge/list",
    },
    promptTemplate: {
      createServiceUrl:
        import.meta.env.VITE_PROMPT_TEMPLATE_CREATE_URL ||
        "/v1/prompt-template/create",
      updateServiceUrl:
        import.meta.env.VITE_PROMPT_TEMPLATE_UPDATE_URL ||
        "/v1/prompt-template/update",
      deleteServiceUrl:
        import.meta.env.VITE_PROMPT_TEMPLATE_DELETE_URL ||
        "/v1/prompt-template/delete",
      listServiceUrl:
        import.meta.env.VITE_PROMPT_TEMPLATE_LIST_URL ||
        "/v1/prompt-template/list",
      getServiceUrl:
        import.meta.env.VITE_PROMPT_TEMPLATE_GET_URL ||
        "/v1/prompt-template/get",
      listVersionsServiceUrl:
        import.meta.env.VITE_PROMPT_TEMPLATE_LIST_VERSIONS_URL ||
        "/v1/prompt-template/list/versions",
    },
  },
  genaiKnowledgeProcessingService: {
    baseUrl:
      import.meta.env.VITE_GENAI_KNOWLEDGE_PROCESSING_BASE_URL ||
      "http://localhost:3005",
    knowledge: {
      createServiceUrl:
        import.meta.env.VITE_KNOWLEDGE_CREATE_SERVICE_URL ||
        "/v1/knowledge/create",
      updateServiceUrl:
        import.meta.env.VITE_KNOWLEDGE_UPDATE_SERVICE_URL ||
        "/v1/knowledge/update",
      filesServiceUrl:
        import.meta.env.VITE_KNOWLEDGE_FILES_SERVICE_URL ||
        "/v1/knowledge/files",
    },
  },
  genAIAnalyticsFastAPIService: {
    baseUrl:
      import.meta.env.VITE_GENAI_ANALYTICS_FASTAPI_BASE_URL ||
      "http://localhost:3000",
    getAnalyticsServerUrl:
      import.meta.env.VITE_GET_ANALYTICS_SERVICE_URL ||
      "/v1/rai-metrics/aggregation/get",
    prometheusQueryServiceUrl:
      import.meta.env.VITE_PROMETHEUS_QUERY_SERVICE_URL ||
      "/v1/performance-evaluation/prometheus/query",
    performanceEvaluationServiceUrl:
      import.meta.env.VITE_PERFORMANCE_EVALUATION_SERVICE_URL ||
      "/v1/performance-evaluation/aggregation/get",
  },
  masterService: {
    baseUrl:
      import.meta.env.VITE_MASTER_SERVICE_BASE_URL ||
      "http://localhost:3001",
    getAllServiceUrl:
      import.meta.env.VITE_MASTER_DATA_ALL_SERVICE_URL ||
      "/v1/master-data/all",
  },
};
